import React, { Component } from "react";
import Content from "../../content/Content";
import style from "../../assets/css/modules/health-support/health-support-item.css";
import SmartLink from "../shared/links/SmartLink";
import { ButtonConfig } from "../../constants/Constants";

export class HealthSupportItem extends Component {
  GetImage(src) {
    return <img src={src} alt="" aria-hidden />;
  }
 GetId =(linktext,flag,id)=>
  {
    if(linktext === "GP Appointments 24/7")
    {
      if(flag ==="worried")
      {
        return ButtonConfig.GPAppointments247;
      }
      else
      return ButtonConfig.GPAppointments247Unwell;
    }
    else if(linktext.Any === "24/7 health support line")
    {
      if(flag ==="worried")
        {
          return ButtonConfig.HealthSupportlineWorried;
        }
        else if(flag ==="unwell")
          return ButtonConfig.HealthSupportLineUnwelll;
        else  
          return ButtonConfig.HealthSupportLineRecover;
    }   
    return id;
  }

  render() {
    return (
      <div className={style.healthSupportItem}>
        <Content names={[this.props.IconSrc, this.props.Heading]}>
          {(src, alt) => this.GetImage(src)}
        </Content>
        <h3>
          <Content name={this.props.Heading} />
        </h3>
        <p>
          <Content name={this.props.Desc} />
        </p>
        <div className={style.links}>
          <Content name={this.props.Links}>
            {(links) =>
              links.map((link, key) => (
                <SmartLink
                  key={key}
                  to={link.LinkTo}
                  isExternalLink={link.ExtLink}
                  id = {this.GetId(link.LinkText,this.props.Flag,link.id)}
                >
                  <Content name={link.LinkText} />
                </SmartLink>
              ))
            }
          </Content>
        </div>
      </div>
    );
  }
}

export default HealthSupportItem;
